export const HOME_CONTENT_DEFAULTS = {
  hero_badge: "GST billing for Indian businesses",
  hero_heading: "Billing and accounting, made",
  hero_highlight: "simpler.",
  hero_description: "Create GST invoices, manage inventory and expenses, and keep your business reports close at hand — all in one workspace.",
  hero_primary_cta: "Create your free account",
  hero_secondary_cta: "Explore features",
  features: [
    { title: "GST invoices", description: "Create professional GST invoices with automatic tax calculations." },
    { title: "Inventory", description: "Track stock, HSN codes and low-stock items as you work." },
    { title: "GST reports", description: "Prepare GSTR-1 and GSTR-3B reports with Excel exports." },
    { title: "Purchases & ITC", description: "Record vendor bills and keep input tax credit organized." },
    { title: "Estimates & orders", description: "Create estimates and purchase orders, then manage them in one place." },
    { title: "Banking", description: "Organize accounts, transactions and imported statements." },
    { title: "Expenses & ledgers", description: "Keep expense records, party balances and business reports together." },
    { title: "Multiple branches", description: "Manage separate business records and settings for each branch." },
    { title: "Share documents", description: "Email invoices or share them through WhatsApp and Telegram." },
  ],
  benefits: [
    { title: "Made for GST workflows", description: "Keep invoicing, purchases and tax reports connected in one place." },
    { title: "Start free", description: "Create an account and get started without a paid plan." },
    { title: "Business records together", description: "Manage inventory, expenses, banking and party balances side by side." },
    { title: "Reports when you need them", description: "Review business activity and export GST reports from one workspace." },
  ],
  cta_heading: "Ready to simplify your billing?",
  cta_description: "Create your free ADS Billing account today.",
  cta_button: "Get started free",
};

export function normalizeHomepageContent(content = {}) {
  return {
    ...HOME_CONTENT_DEFAULTS,
    ...content,
    features: HOME_CONTENT_DEFAULTS.features.map((item, index) => ({
      ...item,
      ...(content.features?.[index] || {}),
    })),
    benefits: HOME_CONTENT_DEFAULTS.benefits.map((item, index) => ({
      ...item,
      ...(content.benefits?.[index] || {}),
    })),
  };
}

export function normalizeSiteContent(content = {}, legalDefaults = {}) {
  const legal = Object.fromEntries(
    Object.entries(legalDefaults).map(([key, document]) => {
      const custom = content.legal?.[key] || {};
      const legacyBillingCopy = typeof custom.content === "string" &&
        /cloud-based GST accounting application|Plans renew automatically|Cashfree Payments and Razorpay|Free plan involves no charge/i.test(custom.content);
      return [
        key,
        {
          title: legacyBillingCopy ? document.title : custom.title || document.title,
          updated: legacyBillingCopy ? document.updated : custom.updated || document.updated,
          content: typeof custom.content === "string" && !legacyBillingCopy
            ? custom.content
            : formatLegalContent(document),
        },
      ];
    }),
  );
  const announcement = content.announcement || {};
  const updates = Array.isArray(announcement.updates) && announcement.updates.length
    ? announcement.updates
    : announcement.title && announcement.message
      ? [{ title: announcement.title, message: announcement.message, link_url: "", link_label: "" }]
      : [];

  return {
    homepage: normalizeHomepageContent(content.homepage),
    legal,
    announcement: {
      active: false,
      title: "",
      message: "",
      ...announcement,
      updates,
    },
  };
}

export function formatLegalContent(document) {
  return document.sections
    .map(([heading, paragraphs]) => `## ${heading}\n\n${paragraphs.join("\n\n")}`)
    .join("\n\n");
}

export function parseLegalContent(content) {
  const sections = [];
  let current = { heading: "Policy", paragraphs: [] };

  for (const block of content.split(/\n\s*\n/).map((part) => part.trim()).filter(Boolean)) {
    if (block.startsWith("## ")) {
      if (current.paragraphs.length) sections.push(current);
      current = { heading: block.slice(3).trim() || "Section", paragraphs: [] };
    } else {
      current.paragraphs.push(block);
    }
  }
  if (current.paragraphs.length) sections.push(current);
  return sections;
}
